export default __webpack_public_path__ + "static/press-release-etravel-81bec8cdd4f87ac206a592dea9d6221c.png";